// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'vue-photo-preview/dist/skin.css'
import router from './router'
import axios from '@/axios'
import Vuex from 'vuex'
import store from '@/store'
import moment from 'moment'//导入文件
import { baseUrls } from '@/util.js'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

import Navigation from 'vue-navigation'

Vue.use(Navigation, {router})

Vue.prototype.$moment = moment;//赋值使用
Vue.prototype.$baseUrls = baseUrls()
import { isAndroid, isIos, getCookie, setCookie,
  setuserToken ,getuserToken,
  setuserCommunity, getuserCommunity,
  setcurrentuserCommunity,
  getcurrentuserCommunity,
  setMovetime ,getMovetime,
   ischeckLogin} from './global'
import * as myCommon from './global'
import preview from 'vue-photo-preview'
import VConsole from 'vconsole'
import { Toast, Indicator } from "mint-ui";
// new VConsole()
if (process.env.NODE_ENV === 'development') {
  // new VConsole()
}
// 判断触屏
function isScreen(url) {
  if(isAndroid() || isIos()) {
    window.location.href = url
  }else{
    window.location.href = commonIp+'/download'
  }
}
// myCommon.ornotLogin()
// 获取用户信息
Vue.use(preview)
Vue.use(Vuex)
// 默认超时时间为30秒
// axios.defaults.timeout = 30000;
// axios.interceptors.response.use(
//   response => {
//     return response
//   },
//   error => {
//     // if (!navigator.onLine) {
//     //   Toast("您的网络已断开");
//     //   Indicator.close()
//     //   return
//     // } else {
//     //   const { code, message } = error;
//     //   if (code === 'ECONNABORTED' || message === 'Network Error') {
//     //     Toast("请求超时，请稍候再试");
//     //   }
//     // }
//     const { code, message } = error;
//     if (!navigator.onLine || code === 'ECONNABORTED' || message === 'Network Error') {
//       // Toast("请求超时，请稍候再试");
//       Indicator.close();
//       return;
//     }

//     return Promise.reject(error);
//   }
// )
Vue.prototype.$axios=axios
Vue.use(Mint);

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app'];
Vue.prototype.myCommon = myCommon
Vue.prototype.isAndroid = isAndroid
Vue.prototype.isIos = isIos
Vue.prototype.isScreen = isScreen
Vue.prototype.setCookie = setCookie
Vue.prototype.getCookie = getCookie
Vue.prototype.setuserToken = setuserToken
Vue.prototype.getuserToken = getuserToken
Vue.prototype.setuserCommunity = setuserCommunity
Vue.prototype.getuserCommunity = getuserCommunity
Vue.prototype.setcurrentuserCommunity = setcurrentuserCommunity
Vue.prototype.getcurrentuserCommunity = getcurrentuserCommunity
Vue.prototype.setMovetime = setMovetime
Vue.prototype.getMovetime = getMovetime
Vue.prototype.commonIp = myCommon.commonIp
Vue.prototype.ischeckLogin = ischeckLogin
// 左滑右滑
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
// setuserToken('')
// 引入vue-amap
import VueAMap from 'vue-amap';
import { lazyAMapApiLoaderInstance } from 'vue-amap';

let commonIp = myCommon.commonIp()
// 获取token
function postToken() {}

let isInit = 0
function getToken(obj) {
  Indicator.close()
  let tobj = obj?JSON.parse(obj):{token:'',mobile:''}
  localStorage.setItem('appuserToken',tobj.token)
  localStorage.setItem('userMobile',tobj.mobile)

}

// if (isAndroid() || isIos()) {
//   //Indicator.open();
//   if(isAndroid()) {
//     if(myCommon.isIframe()) {
//       window["getUser"] = getToken
//       window.app.postToken('postToken')
//     }
//   }else if(isIos()) {
//     window.getUser = getToken
//     window.webkit.messageHandlers.postToken.postMessage('')
//   }
// }else{
//   axios.get(`${commonIp}/v1/mobile/community/userInfo`)
//     .then((res) => {
//       if(res.data.code=='200') {
//         setuserToken(res.data.data.token)
//         localStorage.setItem('userMobile',res.data.data.mobile)
//       }else{
//         console.log(res)
//       }
//     }).catch((error) => {
//       console.log(error)
//       // alert('error====',error)
//       // Toast(error.msg)
//     })
// }

function initApp(){
    if (isAndroid() || isIos()) {
      if(isAndroid()) {
        if(myCommon.isIframe()) {
          Indicator.open()
          window["getUser"] = getToken
          window.app.postToken('postToken')
        }
      }else if(isIos()) {
        if(myCommon.isIframe()) {
          Indicator.open()
          window.getUser = getToken
          window.webkit.messageHandlers.postToken.postMessage('')
        }
      }
    
      setTimeout(function(){
        initVue()
      },200)
      
    }else{
      axios.get(`${commonIp}/v1/mobile/community/userInfo?ckdata=1`)
        .then((res) => {
          if(res.data.code=='200') {
            localStorage.setItem('appuserToken',res.data.data.token)
            localStorage.setItem('userMobile',res.data.data.mobile)
          }else{
            // console.log(res)
          }
          initVue()
        }).catch((error) => {
          console.log(error)
          initVue()
        })

    }
}

function initVue(){
  isInit = 1
  Vue.config.productionTip = false;
  Vue.use(VueAMap);
  VueAMap.initAMapApiLoader({
    key: "9684a36adacb0ae49e22c8aed1388dd6",
    plugin: [
      'AMap.Autocomplete',
      'AMap.PlaceSearch', // POI搜索插件
      'AMap.Scale', // 右下角缩略图插件 比例尺
      'AMap.ToolBar', // 地图工具条
      'AMap.CircleEditor', // 圆形编辑器插件
      'AMap.Geolocation', // 定位控件，用来获取和展示用户主机所在的经纬度位置
      'AMap.Geocoder'
    ],
    uiVersion: '1.0'
  })
  Vue.prototype.AMap = lazyAMapApiLoaderInstance.load()
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
  
}

initApp()



// WEBPACK FOOTER //
// ./src/main.js